const Divider = ({ className = '' }) => (
  <hr className={`divider ${className}`} />
);

export default Divider;